<template>
    <div id="event">
        <navbar v-if="$store.state.user._id" :transparent="false" position="fixed" :class="{'mb-0':($route.name=='website-types')}">
            <div class="navbar-wrapper">
                <router-link class="navbar-brand" :to="{ name: 'events' }">
                    {{ $store.state.props.appName }}
                </router-link>
                <router-link class="navbar-brand" :to="{ name: 'dashboard', params: { eventId: $route.params.eventId } }">
                    Dashboard
                </router-link>
                <router-link v-if="$store.state.user && $store.state.user._id" class="navbar-brand" :to="{ name: 'attendees' }">
                    Attendees
                </router-link>
            </div>
        </navbar>

        <div class="row justify-content-center" :class="{'website-background-image pt-5':($route.name=='website-types'), 'mt-5':($route.name!='website-types')}">
            <div
                v-if="loading"
                class="col-12 mt-5"
                v-loading="true"></div>
            <div v-else class="col-10">
                <FadeTransition :duration="200" mode="out-in">
                    <router-view/>
                </FadeTransition>
            </div>
            <p class="copyright">{{$version? `${$version} |`:'' }} All rights reserved eventscoded.com | Questions/Support: <a href="mailto:info@eventscoded.com">info@eventscoded.com</a></p>
        </div>

        <el-dialog
            title="Terms And Conditions"
            :visible.sync="$store.state.dialogs.termsAndConditions">
                <div v-html="$store.state.event.termsAndConditions"></div>
        </el-dialog>
    </div>
</template>

<script>
import { FadeTransition } from 'vue2-transitions'
import { Navbar } from '@/components/now-ui'

export default {
    components: {
        Navbar,
        FadeTransition
    },
    data () {
        return {
            loading: true
        }
    },
    mounted () {
        this.getData()
    },
    methods: {
        getData: async function () {
            this.loading = true
            let params = { filters: { eventId: this.$route.params.eventId } }
            try {
                await Promise.allSettled([
                    this.$store.dispatch('getUser'),
                    this.$store.dispatch('get', { path: 'events', key: 'event', id: this.$route.params.eventId }),
                    this.$store.dispatch('getAll', { path: 'types', params }),
                    this.$store.dispatch('getAll', { path: 'speakers', params }),
                    this.$store.dispatch('getAll', { path: 'activities', params })
                ])
            } catch (e) {
                console.log(e);
                console.log('error loading data')
            }
            this.loading = false
        }
    }
};
</script>

<style lang="sass">
#event
    h1
        font-size: 32px


</style>
<style>
    .website-background-image{
    background-image:url(../../assets/img/rsz_bg-6.jpg);
    padding:15px;
    background-size: cover;
}
</style>